import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Footer from "./components/Footer";
import Header from "./components/Header";
import Error from "./components/Error";
import WalletSelector from "./components/WalletSelector";
import Web3Automation from "./components/Web3Automation";
import { config } from './config/wagmi';

const StyledApp = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

const queryClient = new QueryClient();

const App = (): JSX.Element => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <StyledApp>
            <Header />
            <Outlet />
            {/* <Footer /> */}
            <Error />
            <WalletSelector />
            <Web3Automation />
          </StyledApp>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
